import clsx from "clsx"
import { useMemo } from "react"

import { getPriorityLabel } from "@utils/priority"

import { PriorityIcon } from "@atoms/index"

import styles from "./PriorityCell.module.scss"
import { PriorityCellProps } from "./PriorityCell.types"

export default function PriorityCell(props: PriorityCellProps) {
    const { variant = "primary", priority } = props

    const priorityRender = useMemo(() => {
        return (
            <>
                <PriorityIcon priority={priority} size={10} />
                <span>{getPriorityLabel(priority)}</span>
            </>
        )
    }, [priority])

    return (
        <div className={clsx(styles.base, styles[variant])}>
            <div className={styles.content}>{priorityRender}</div>
        </div>
    )
}
